import { nextTick, ref, unref, watch } from 'vue';

export const useReportLoading = loadingSource => {
  const visibleLoading = ref(Boolean(unref(loadingSource)));
  let updateId = 0;

  watch(
    loadingSource,
    async isLoading => {
      updateId += 1;
      const currentUpdateId = updateId;

      if (isLoading) {
        visibleLoading.value = true;
        return;
      }

      await nextTick();
      if (currentUpdateId === updateId) {
        visibleLoading.value = false;
      }
    },
    { flush: 'post' }
  );

  return visibleLoading;
};
